import { Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { Observable } from 'rxjs';
import {
  CurrencyRatesService,
  PaymentTermsService
} from '@api-accounting-client';

import {
  CreateOrderCommand,
  SalesOrdersService,
  SetOrderStatusCommand
} from '@api-client';

import { SalesOrdersBaseComponent } from '../salesOrdersBaseComponent';
import {
  DialogExtendedService,
  NotificationsExtendedService
} from '../../../shared/services';
import { SalesInvoiceDataSharingService } from '../../../shared/services/data-helper';
@Component({
  selector: 'app-sales-order-add',
  templateUrl: './sales-order-add.component.html',
  styleUrls: ['./sales-order-add.component.scss'],
  standalone: false
})
export class SalesOrderAddComponent
  extends SalesOrdersBaseComponent
  implements OnInit, OnDestroy
{
  constructor(
    protected formBuilder: UntypedFormBuilder,
    protected salesOrdersService: SalesOrdersService,
    protected paymentTermsService: PaymentTermsService,
    protected currencyRatesService: CurrencyRatesService,
    protected dialogExtendedService: DialogExtendedService,
    protected notificationsExtendedService: NotificationsExtendedService,
    protected salesInvoiceDataSharingService: SalesInvoiceDataSharingService
  ) {
    super(
      formBuilder,
      salesOrdersService,
      paymentTermsService,
      currencyRatesService,
      dialogExtendedService,
      notificationsExtendedService,
      salesInvoiceDataSharingService
    );
  }

  async ngOnInit(): Promise<void> {
    super.ngOnInit();
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  onDataSubmit(command: CreateOrderCommand): Observable<any> {
    return this.salesOrdersService.salesOrdersPost(command);
  }

  onStatusSubmit(command: SetOrderStatusCommand): Observable<any> {
    return this.salesOrdersService.salesOrdersStatusPatch(
      command,
      this.salesOrderUid
    );
  }
}
